/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useEffect, useRef } from 'react';
import { Form, Formik } from 'formik';
import { TextArea2 } from 'components/Dialog';
import Icon from 'components/Icon';

import {
  Dialog,
  DialogBody,
  DialogCancel,
  DialogConfirm,
  ContentTextArea,
  CardHeader,
  IconsContainer,
  IconAddContainer,
} from './styles';

export default function NotesModal({ onSubmit, show, handleClose, notesHistory }) {
  const [visible, setVisible] = useState(show);

  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState("");

  const myRef = useRef();

  useEffect(() => {
    setVisible(show);
  }, [show]);

  useEffect(() => { }, [])

  const handleSubmit = () => {
    onSubmit(value);
    setIsEditing(false);
    setValue('');
  }

  return (
    <Dialog canShow={visible} >
      <DialogBody ref={myRef}>
        <CardHeader >
          <div>
            Payment Notes
          </div>
          <IconsContainer>
            <Icon
              name="Close"
              className="icon-close"
              onClick={() => {
                handleClose();
                setIsEditing(false)
                setValue('')
              }}
            />
          </IconsContainer>
        </CardHeader>
        <IconAddContainer>
          <Icon
            name="add"
            className="icon-add"
            onClick={() => {
              setIsEditing(true)
            }}
          />
        </IconAddContainer>
        <Formik
          initialValues={{
            notes: ''
          }}
          onSubmit={() => handleSubmit()}>
          <Form>
            <ContentTextArea>
              <TextArea2
                value={isEditing ? value : notesHistory}
                onChange={(e) => setValue(e.target.value)}
                disabled={!isEditing}
              />
            </ContentTextArea>
            {isEditing && (
              <>
                <DialogCancel
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setIsEditing(false)
                    setValue('')
                  }}
                >
                  Cancel
                </DialogCancel>
                <DialogConfirm type="submit">Confirm</DialogConfirm>
              </>
            )}

          </Form>
        </Formik>
      </DialogBody>
    </Dialog>
  );
}